export const safeDiv = (a: number, b: number) => {
  if (a === 0 && b === 0) return 0

  return a / b
}
